import { sendErrorLog } from './logClient'
import { ErrorLogSource } from '../@types/errorLog'

const apiUrl = 'https://api.finanzen.immobilienscout24.de/phonenumber-utils/format'

interface PhoneFormatResponse {
  formattedNumber?: string
  error?: number
  message?: string
}
export const fetchPhoneNumberFormatted = (phoneNumber: string): Promise<PhoneFormatResponse> =>
  fetch(apiUrl, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      number: phoneNumber,
      country: 'DE',
    }),
  })
    .then((response) => {
      if (!response.ok) throw new Error(`${response.status}`)
      return response.json()
    })
    .catch((error) => {
      const errorMessage = `Error while formatting phone number, phone number: ${phoneNumber}, error: ${error.message}`
      if (error.message != '400') {
        sendErrorLog({
          message: errorMessage,
          source: ErrorLogSource.PHONE_NUMBER_FORMAT,
        })
      }
      throw new Error(errorMessage)
    })
